import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ContentApi, type GetServicesResponse } from '@shared/api';

interface ServicesType {
  data: GetServicesResponse[];
  loading: boolean;
  error: string | null;
  getServices: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useServicesStore = create<ServicesType>((set) => ({
  data: [],
  loading: false,
  error: null,

  getServices: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ContentApi.getServices(signal);
      set({ data: result ?? [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
